export const ManageAlertsIcon = ({ fill = '#fff', hoverFill = '#FAFAFA' }) => {
  return (
    <svg
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28.5" r="28" fill={hoverFill} />
      <circle cx="28" cy="28.5" r="28" stroke="#E9E9E9" />
      <rect
        width="24"
        height="24"
        transform="translate(16 16.5)"
        fill={hoverFill}
      />
      <path
        d="M20 35.5V33.5H22V26.5C22 25.1167 22.4167 23.8875 23.25 22.8125C24.0833 21.7375 25.1667 21.0333 26.5 20.7V20C26.5 19.5833 26.6458 19.2292 26.9375 18.9375C27.2292 18.6458 27.5833 18.5 28 18.5C28.4167 18.5 28.7708 18.6458 29.0625 18.9375C29.3542 19.2292 29.5 19.5833 29.5 20V20.7C30.8333 21.0333 31.9167 21.7375 32.75 22.8125C33.5833 23.8875 34 25.1167 34 26.5V33.5H36V35.5H20ZM28 38.5C27.45 38.5 26.9792 38.3042 26.5875 37.9125C26.1958 37.5208 26 37.05 26 36.5H30C30 37.05 29.8042 37.5208 29.4125 37.9125C29.0208 38.3042 28.55 38.5 28 38.5ZM24 33.5H32V26.5C32 25.4 31.6083 24.4583 30.825 23.675C30.0417 22.8917 29.1 22.5 28 22.5C26.9 22.5 25.9583 22.8917 25.175 23.675C24.3917 24.4583 24 25.4 24 26.5V33.5Z"
        fill={fill}
      />
    </svg>
  );
};

export const RespManageAlertsIcon = ({ fill = '#fff' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" fill="#FAFAFA" />
      <path
        d="M4 19V17H6V10C6 8.61667 6.41667 7.3875 7.25 6.3125C8.08333 5.2375 9.16667 4.53333 10.5 4.2V3.5C10.5 3.08333 10.6458 2.72917 10.9375 2.4375C11.2292 2.14583 11.5833 2 12 2C12.4167 2 12.7708 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8333 4.53333 15.9167 5.2375 16.75 6.3125C17.5833 7.3875 18 8.61667 18 10V17H20V19H4ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8042 12.55 22 12 22ZM8 17H16V10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10V17Z"
        fill={fill}
      />
    </svg>
  );
};
